import { filterItems } from "components/terminal/Navigation/Search/Search.utils"
import { useMemo } from "react"
import { useApplyDataFilters } from "../DataFilterForm/useDataFilter"
import {
  type TextFilterId,
  useDeferredTextFilter,
} from "./asideTextFilterHooks"

/*
 * Combines text filter atom based data and
 * router based data filter form rules to filter data under one memo
 * to avoid unnecessary nested memoed data
 */

export const useFilteredData = <T extends object>(
  data: T[],
  textFilterParams: Array<keyof T>,
  id: TextFilterId
) => {
  const textFilter = useDeferredTextFilter(id)
  const applyDataFilters = useApplyDataFilters()

  return useMemo(() => {
    if (!data) {
      return data
    }

    let filtered: T[] = data

    if (textFilter) {
      filtered = filterItems(
        {
          items: data,
          keys: textFilterParams,
        },
        textFilter
      )
    }

    return applyDataFilters(filtered)
  }, [data, textFilter, textFilterParams, applyDataFilters])
}
